const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDictEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M231.7,254.1H39.7c-13.2-.3-23.7-11-23.7-24.2V26.1c0-13.3,10.8-24.2,24.2-24.2,0,0,.1,0,.2,0h176c13.2.3,23.7,11,23.7,24.2v155.4c0,6.5-2.4,12.7-7,17.3-6.4,5.9-15,8.8-23.7,8-22.9-.8-164.3,0-165.8,0-3.1-.3-6.2.6-8.6,2.4-1.7,2-2.5,4.6-2.2,7.2v13.6c0,4.4,3.4,8.1,7.8,8.2,0,0,.1,0,.2,0h192c4.4,0,8,3.6,8,8,0,4.4-3.5,8-7.9,8.1-.3,0-.7,0-1,0ZM40.3,17.9c-4.4,0-8,3.6-8,8,0,0,0,.1,0,.2v165.9c3.7-1.2,7.6-1.8,11.5-1.6,5.1,0,142.4-.8,165.6,0,4.2.5,8.5-.6,11.8-3.2,1.5-1.6,2.3-3.6,2.4-5.8V26.1c0-4.4-3.4-8.1-7.8-8.2,0,0-.1,0-.2,0H40.3Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8,175.3l12.3,6.7,22.3-14.4-37.1-19.4,2.4,27h0ZM171.5,47.9l-35.4-18.6c-6.6-3.4-14.9-.8-19,5.9l-6.6,12.7,60.1,31.2,6.6-12.7c4.1-6.7.8-15.2-5.8-18.6h0ZM123.7,63.2l-15.6-7.6c-9.9,21.1-20.6,41.3-30.5,62.4,1.7,8.4,5,12.7,12.3,10.1l21.4-42.2,4.1,1.7-21.4,41.3c5.8,11.8,15.6,14.4,27.2,12.7,1.7,9.2,5.8,14.4,15.6,8.4l30.5-62.4-15.6-8.4-28.1-16h0Z",
    style: {
      fill: "#f22",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDictEdit);
export default __webpack_public_path__ + "static/media/dict-edit.8438c7ec770e9c5030d104a489aac53d.svg";
export { ForwardRef as ReactComponent };